/* global chrome */

// inject chromecast sender script
export function injectChromecastScript() {
  const senderScript = document.createElement('script');
  senderScript.src = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';
  document.head.appendChild(senderScript);
}

export function getTrackId(tracks, preferredId, type) {
  const track = tracks.find(item => item.language === preferredId && item.type === type);

  return track?.trackId;
}

export function getSelectedLanguage(activeTracksIds, tracks) {
  const activeTrackId = activeTracksIds.find(id => tracks.find(track => track.trackId === id));

  if (!activeTrackId) {
    return 'off';
  }

  const activeTrack = tracks.find(track => track.trackId === activeTrackId);

  return activeTrack?.language || 'off';
}

export async function requestChromeCastSession() {
  return new Promise((resolve, reject) => {
    chrome.cast.requestSession(
      requestedSession => resolve(requestedSession),
      reject,
    );
  });
}
